import {W4Type} from "@app/shared/enums/w4-type.enum";

export class SteJurisdictionParm {
  id: number;
  version: number;
  w4Type: W4Type;
  uniqueTaxID: string;
  stateAbbreviation: string;
  stateCode: string;
  parmName: string;
  description: string;
  regex: string;
  regexType: string;
  regexDescription: string;
  certificateLineNo: string;
  listValues: string;
  defaultValue: string;
  helpText: string;
  dataType: string;
  isOptional: boolean;
  orgId: number;
}

export class ParameterValueMap {
  FEDERAL?: any;
  STATE?: any;
  LOCAL?: any;
}

export class TaxItemInfo {
  year: string;
  w4Type: W4Type;
  uniqueTaxID: string;
  taxRate: string;
  wageBase: number;
  taxLimit: number;
  locationCode: string;
  description: string;
  resident: boolean;
  employerTax: boolean;
}


export class TaxInfo {
  status: boolean;
  taxInformation: string;
}


export class JurisdictionData {
  uniqueTaxID: string;
  stateAbbreviation: string;
  stateCode: string;
  description: string;
  regex: string;
  regexType: string;
  regexDescription: string;
  certificateLineNo: string;
  listValues: string;
  defaultValue: string;
  helpText: string;
  dataType: string;
  isOptional: boolean;
  parameterName: string;
  options?: any[];
}


export class FormData {
  localFormData: any;
  stateFormData: any;
  fedralFormData: any;
}